export enum PaymentMethodType {
    CASH = 'CASH',
    MONEY_TRANSFER = 'MONEY_TRANSFER',
    WARRENTY = 'WARRENTY',
    OTHER = 'OTHER',
    CARD = 'CARD',
}
